export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-arrow-right-91d19d4fdee8f8269583f87db11eee52.png";